import styled from 'styled-components'
import { BodyDefault } from '../typography/styled';

type SelectProps = {
  active:boolean;
}

type ActiveProp = {
  active?:boolean;
}

export const Container = styled.div`
  position: relative;
  /* height:100%; */
  display: flex;
  flex-direction: column;
  align-items: flex-start;
  justify-content: flex-start;
`
export const DropDown = styled.button.withConfig({
  shouldForwardProp: (prop) => prop !== 'active',
})<SelectProps>`
  appearance: none;
  box-sizing: border-box;
  display: flex;
  justify-content: space-between;
  align-items: center;
  /* width: 100% ; */
  /* height: 40px; */
  background-color: ${({theme, active}) => active ? theme.palette[10] : theme.primary[50]};
  padding: 10px 16px;
  box-shadow: ${({active, theme}) => active ? theme.isDark ? theme.shadows.focusDark : theme.shadows.focus : ''};
  border-radius: ${({theme}) => theme.radius.control};
  border: ${({theme, active}) => active ? `1px solid ${theme.accent[100]}` : ''};
  color: ${({theme}) => theme.primary[700]};
  &:hover{
    cursor: pointer;
    color: ${({theme}) => theme.primary[500]};
    > span {
      color: ${({theme, active}) => active ? theme.primary[700] : theme.primary[500]};
    }
  }
  &:focus-visible{
    outline: none;
    border: ${({theme}) => `1px solid ${theme.accent[100]}`};
    box-shadow: ${({theme}) => theme.isDark ? theme.shadows.focusDark : theme.shadows.focus};
  }
  /* &:target{
    border: ${({theme}) =>  `1px solid ${theme.primary[300]}`};
    box-shadow: '0px 0px 0px 3px #E0EAFF';
  } */
`

export const ImgArrow = styled.img.withConfig({
  shouldForwardProp: (prop) => prop !== 'active',
})<ActiveProp>`
  transform: ${({active}) => active ? 'rotate(180deg)' : ''};
`
export const Title = styled(BodyDefault).withConfig({
  shouldForwardProp: (prop) => prop !== 'active',
})<ActiveProp>`
  white-space: nowrap;
  color:${({theme}) => theme.primary[700]};
`

export const OptionsWrapper = styled.div.withConfig({
  shouldForwardProp: (prop) => prop !== 'active',
})<ActiveProp>`
  /* top: 49px; */
  margin-top: ${({active}) => active ? '10px' : '0px'};;
  /* position: absolute; */
  margin-bottom: ${({active}) => active ? '10px' : '0px'};
  display: flex;
  flex-direction: column;
  box-sizing: border-box;
  z-index: 6;
  border-radius: ${({theme}) => theme.radius.control};
  padding: ${({active}) => active ? '20px' : '0px'};
  background-color: ${({theme}) => theme.palette[10]};
  width: 100%;
  box-shadow: ${({theme}) => theme.isDark ? theme.shadows.focusDark : theme.shadows.focus};
  height:${({active}) => active ? '' : '0px'};
  transform:${({active}) => active ? 'scale(1)' : 'scale(0)'};
  transform-origin: top;
  transition: 0.1s transform ease-in-out;
  transition: 0.2s opacity, height ease-in-out;
  opacity:${({active}) => active ? '1' : '0'};
`
